import { render, staticRenderFns } from "./TaskTypeMaterialModal.vue?vue&type=template&id=c0aa8664&"
import script from "./TaskTypeMaterialModal.vue?vue&type=script&lang=js&"
export * from "./TaskTypeMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0aa8664')) {
      api.createRecord('c0aa8664', component.options)
    } else {
      api.reload('c0aa8664', component.options)
    }
    module.hot.accept("./TaskTypeMaterialModal.vue?vue&type=template&id=c0aa8664&", function () {
      api.rerender('c0aa8664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/TaskTypeMaterialModal.vue"
export default component.exports